{
  "name": "Kicgle",
  "version": "2026.11.05.09.10.46",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "dev": "node scripts/dev.js",
    "prebuild": "node scripts/update-version.js",
    "build": "node scripts/build.js",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "icons": "node scripts/generate-pwa-icons.js",
    "serve:ssr:app": "node dist/app/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^21.0.0",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/material": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/platform-server": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@angular/service-worker": "^21.2.11",
    "@angular/ssr": "^21.0.0",
    "@cashfreepayments/cashfree-js": "^1.0.7",
    "@google/genai": "^1.27.0",
    "@tailwindcss/typography": "^0.5.19",
    "axios": "^1.15.0",
    "d3": "^7.9.0",
    "express": "^5.1.0",
    "firebase": "^12.13.0",
    "firebase-admin": "^14.5.0",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.2.1",
    "modern-screenshot": "^4.6.8",
    "motion": "^12.23.24",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.0",
    "@angular/cli": "^21.0.0",
    "@angular/compiler-cli": "^21.0.0",
    "@tailwindcss/postcss": "^4.1.12",
    "@types/d3": "^7.4.3",
    "@types/express": "^5.0.1",
    "@types/node": "^20.17.19",
    "angular-eslint": "21.1.0",
    "cross-env": "^10.1.0",
    "eslint": "^9.39.1",
    "jsdom": "^27.0.0",
    "postcss": "^8.5.3",
    "sharp": "^0.35.5",
    "tailwindcss": "^4.1.12",
    "typescript": "~5.9.2",
    "typescript-eslint": "8.47.0",
    "vitest": "^4.0.0"
  }
}
